import { NavLink } from "react-router";
import { useTranslation } from "react-i18next";
import { clsx } from "clsx";
import { CalendarDays, Clock3, ListTodo, Settings } from "lucide-react";
import type { DocHandle } from "../sync/docManager";
import { DashboardsMenu } from "./DashboardsMenu";

const tab =
  "flex min-h-14 min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-sm px-0.5 text-[11px] tracking-[-0.01em] text-neutral-500 hover:text-neutral-900 dark:hover:text-neutral-100";
const active = "text-accent dark:text-accent";

/**
 * The primary navigation on narrow layouts: the five places of the app bar as a bar at the bottom, where a thumb
 * reaches them (with the phone's safe-area inset). Icons always carry their word.
 */
export function TabBar({ core }: { core: DocHandle | null }) {
  const { t } = useTranslation();
  const items = [
    { to: "/list", label: t("nav.list"), icon: ListTodo },
    { to: "/planner", label: t("nav.planner"), icon: CalendarDays },
    { to: "/worklog", label: t("nav.worklog"), icon: Clock3 },
    { to: "/settings", label: t("nav.settings"), icon: Settings },
  ];
  return (
    <nav
      aria-label="primary"
      className="flex shrink-0 items-stretch gap-1 border-t border-neutral-200 bg-[var(--ground)] px-2 pb-[env(safe-area-inset-bottom)] dark:border-neutral-800"
      data-testid="tab-bar"
    >
      <DashboardsMenu core={core} variant="tab" />
      {items.map(({ to, label, icon: Icon }) => (
        <NavLink key={to} to={to} className={({ isActive }) => clsx(tab, isActive && active)}>
          <Icon size={20} aria-hidden />
          <span className="max-w-full truncate">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
